<ng-container *ngIf="settingsService.getSettingBoolean('UsesCloudProviderApi')" [ngSwitch]="mainService.getShopPortalLayoutKind()">    
    <app-license-plates-boxed *ngSwitchDefault></app-license-plates-boxed>
    <app-license-plates-webshop *ngSwitchCase="1"></app-license-plates-webshop>
</ng-container>
